module.exports = __webpack_public_path__ + "7fc4a404bb31e2ef9c3f552710ce200d.png";